import baseAPI from '../services/api-service';

const getAWSPresignedUploadUrl = async (sessionToken, fileKey, contentType) => {
  if (!sessionToken) return undefined;

  const apiService = baseAPI(sessionToken);

  return apiService.get(`files/presigned-url?fileKey=${fileKey}&contentType=${contentType}`);
};

const functions = {
  getAWSPresignedUploadUrl,
};

export default functions;
